
import { IEntityMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Passenger from '@/components/Passenger/models/Passenger';
import MappingPropertyInput from '@/components/Importer/MappingPropertyInput.vue';
import DestinationSelector from '@/components/Passenger/components/DestinationSelector.vue';
import Destination from '@/components/Passenger/models/Destination';
import PassengerUtilityMapper from '@/components/Importer/passenger/PassengerUtilityMapper.vue';
import PhoneNumbersMapper from '@/components/Importer/phoneNumber/PhoneNumbersMapper.vue';
import { IMappers } from '../ImportSelectionStep.vue';
import IPassengerPhonNumberViewModel from '@/components/Passenger/models/IPassengerPhoneNumberViewModel';

@Component({
  components: {
    DestinationSelector,
    MappingPropertyInput,
    PassengerUtilityMapper,
    PhoneNumbersMapper,
  },
})
export default class PassengerImportMapper extends Vue {
  mainDestination: Destination | null;
  secondaryDestination: Destination | null;
  mapping: IEntityMapping<Passenger> | null = null;

  showMappings: boolean = true;

  @Prop({ required: true }) value: IEntityMapping<Passenger>;
  @Prop({ required: true }) mappings: IMappers;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.mapping = this.value;
  }

  @Watch('mapping', { deep: true, immediate: true }) onMappingChanged() {
    this.$emit('input', this.mapping);
  }

  get organizationId(): string | null {
    return this.$route.params.organizationId ?? null;
  }

  get destinations(): Destination[] {
    return this.$store.state.destination.destinations;
  }

  selectMainDestination(destinationId: number) {
    const destination = this.destinations.find(d => d.id === destinationId);
    this.mainDestination = destination || null;
    
    const prop = this.mapping.props.find(p => p.propertyName === 'destination');
    if (prop) {
      prop.static = destination.alias;
    }
  }
  selectSecondaryDestination(destinationId: number) {
    const destination = this.destinations.find(d => d.id === destinationId);
    this.secondaryDestination = destination || null;
    
    const prop = this.mapping.props.find(p => p.propertyName === 'secondaryDestination');
    if (prop) {
      prop.static = destination.alias;
    }
  }

  onPhoneNumberMappingsChanged(mappings: Array<IEntityMapping<IPassengerPhonNumberViewModel>>) {
    this.$emit('phoneNumberMappingsChange', mappings);
  }

}
